import { Line } from 'react-chartjs-2';
import classes from './TimeSeriesChart.module.css'
import { externalTooltipHandler } from './customChartTooltip';
import { TIMESERIES_MEMORIAM_TEXT } from '../../../../constants/app';

const TimeSeriesChart = (props) => {
    const { dates, values } = props.timeseriesFireRiskData;
    const isTimeseriesHidden = props.isTimeseriesHidden;
    let width, height, gradient;

    const formattedFireRisks = values && values.map(fireRiskValue => (Math.round(fireRiskValue * 100)) / 10);

    function getGradient(ctx, chartArea) {
        const chartWidth = chartArea.right - chartArea.left;
        const chartHeight = chartArea.bottom - chartArea.top;
        if (gradient === null || width !== chartWidth || height !== chartHeight) {
            // Create the gradient because this is either the first render
            // or the size of the chart has changed
            width = chartWidth;
            height = chartHeight;
            gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
            gradient.addColorStop(0, '#45c0f0');
            gradient.addColorStop(0.45, '#b5d269');
            gradient.addColorStop(0.55, '#f9bb71');
            gradient.addColorStop(0.70, '#ff8157');
            gradient.addColorStop(1, '#ff3e51');
        }

        return gradient;
    }

    const data = {
        labels: dates,
        datasets: [
            {
                label: 'Fire Risk',
                tension: 0.5,
                data: formattedFireRisks,
                borderColor: function (context) {
                    const chart = context.chart;
                    const { ctx, chartArea } = chart;

                    if (!chartArea) {
                        // This case happens on initial chart load
                        return null;
                    }
                    return getGradient(ctx, chartArea);
                },
            },
        ]
    };

    const options = {
        maintainAspectRatio: false,
        scales: {
            y: {
                display: false,
                beginAtZero: true,
                suggestedMin: 0.5,
                suggestedMax: 10
            },
            x: {
                position: 'top',
                display: true,
                grid: {
                    color: '#66787E'
                },
                ticks: {
                    display: false,
                },
            }
        },
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: false,
                external: externalTooltipHandler,
                position: 'nearest'
            }
        },
        events: [
            'click',
            'mousemove'
        ],
        tooltips: {
            mode: 'point'
        },
        onClick: function (evt, context) {
            if (context[0] && context[0].element) {
                const dateIndex = context[0].element.$context.dataIndex;
                props.onTimeseriesPointClick(dates[dateIndex])
            }
        },
        onHover: (event, chartElement) => {
            if (event && event.native && event.native.target) {
                event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
            }
        }
    };

    if (document.getElementById('chartTooltip')) {
        document.getElementById('chartTooltip').addEventListener('click', (e) => {
            const date = document.getElementById('chartTooltip').getAttribute('data-date-info');
            props.loadRaster(date);
        });
    }

    const onChartButtonClick = () => props.setIsTimeseriesHidden(!isTimeseriesHidden);

    return (
        <div className={classes.container}>
            <div className={`${classes.timeseriesContainer} ${!isTimeseriesHidden ? classes.timeseriesContent : ''}`}>
                <p className={classes.chartButton} onClick={onChartButtonClick}>
                    Timeseries <i className={isTimeseriesHidden ? 'fa fa-arrow-up' : 'fa fa-arrow-down'} />
                </p>
                <p className={classes.memoriamText}>{TIMESERIES_MEMORIAM_TEXT}</p>
            </div>
            {!isTimeseriesHidden &&
                <div className={classes.chartContainer}>
                    <Line height={125} data={data} options={options} />
                </div>
            }
        </div>
    );
}

export default TimeSeriesChart;
